import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select';

interface CountryOption {
  value?: string;
  label?: string;
  divider?: boolean;
}

interface CountrySelectProps {
  value?: string;
  onChange: (value?: string) => void;
  options: CountryOption[];
  disabled?: boolean;
  readOnly?: boolean;
}

export function CountrySelect({
  value,
  onChange,
  options,
  disabled,
}: CountrySelectProps) {
  const countries = options.filter((opt) => !opt.divider && opt.value);

  return (
    <Select
      value={value || ''}
      onValueChange={(val) => onChange(val === 'ZZ' ? undefined : val)}
      disabled={disabled}
    >
      <SelectTrigger className="h-12 w-[140px] bg-white border border-gray-300 rounded-md focus:border-accent-purple focus:ring-accent-purple focus:outline-none">
        <SelectValue placeholder="Country">
          {value && (
            <span className="flex items-center gap-2">
              <span className="text-lg">{getUnicodeFlagIcon(value)}</span>
              {value}
            </span>
          )}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-[300px] overflow-y-auto">
        {countries.map((opt) => (
          <SelectItem key={opt.value} value={opt.value!}>
            <span className="flex items-center gap-2">
              <span className="text-lg">{getUnicodeFlagIcon(opt.value!)}</span>
              {opt.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
